import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import { DocumentationIcon } from '../../../icons/DocumentationIcon';
import CopilotActionCard from './CopilotActionCard';
import { type CopilotSearchSourcePage } from '../types';

/**
 * Renders knowledge-search hits grouped by source page: one action card per page.
 */
export const CopilotSearchSourcesDetail = t0 => {
  const $ = _c(4);
  const {
    searchDetails
  } = t0;
  if (searchDetails.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== searchDetails) {
    t1 = searchDetails.map(_temp);
    $[0] = searchDetails;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default CopilotSearchSourcesDetail;
function _temp(page) {
  return <CopilotActionCard key={page.title} icon={<DocumentationIcon />} label={page.title} />;
}